import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCustomizationsSetting, fetchOfaSetting, fetchTenantSetting } from './appInfoApi';
//import CallServer from '../../api/CallServer';
import { GetFromLocalStorage, SaveToLocalStorage } from '../../utils/utils';
import { TENANT, BASE_URL, API_URL } from '../../config/constants';

const initialState = {
  base_url: BASE_URL,
  api_url: API_URL,
  is_default: TENANT === "start" ? true : false,
  error: null,
  personalizations: GetFromLocalStorage('customization_settings') || null,
  tenant_settings: null,
  esse3_integration_enabled: false
};

export const loadAppCustomizationsData = createAsyncThunk(
  'appInfo/loadStaticData',
  async () => {
      const response = await fetchCustomizationsSetting();
      if (response?.success) {
          const [response_2, response_ofa] = await Promise.all([fetchTenantSetting(), fetchOfaSetting()]);
          if (response_2?.success) {
              SaveToLocalStorage("customization_settings",response.data);
              document.title = response?.data?.app_name
              return {
                app: response?.data,
                tenant: response_2?.data,
                // only the flag is kept, the ofa settings contain the esse3 credentials
                esse3_integration_enabled: !!response_ofa?.data?.esse3_integration_enabled
              }
          } else {
            SaveToLocalStorage("customization_settings",response.data);
            document.title = response?.data?.app_name
            return {
              app: response?.data,
              tenant: null
            }
          }
      } else {
        return response
      }
  }
);

export const appInfoSlice = createSlice({
  name: "appInfo",
  initialState,
  reducers: {
    setInfoData: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.personalizations = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAppCustomizationsData.fulfilled, (state, action) => {
        if(!action?.payload?.error){
          state.personalizations = action?.payload?.app;
          state.tenant_settings = action?.payload?.tenant;
          state.esse3_integration_enabled = !!action?.payload?.esse3_integration_enabled;
        } 
        else {
          state.error = action?.payload?.error;
          
        }  
          
      });
  },
});
export default appInfoSlice.reducer;

export const selectAppInfo = (state) => state.appInfo;
export const selectBaseUrl = (state) => state.appInfo.base_url;
export const selectApiUrl = (state) => state.appInfo.api_url;
export const selectAppPersonalizations = (state) => state.appInfo.personalizations;
export const selectTenantSettings = (state) => state.appInfo.tenant_settings;
// esse3 / ofa features are shown only to the ofa and self assessment tenants, or when the esse3 integration is active
export const selectShowOfaFeatures = (state) => !!(
  state.appInfo.tenant_settings?.is_ofa ||
  state.appInfo.tenant_settings?.is_self_assessment ||
  state.appInfo.esse3_integration_enabled
);